const TONE: Record<string, string> = {
  success: 'text-ok', stored: 'text-ok', verified: 'text-ok', ok: 'text-ok', enabled: 'text-ok', active: 'text-ok',
  failed: 'text-danger', danger: 'text-danger', error: 'text-danger', inactive: 'text-danger', removed: 'text-danger',
  partial: 'text-warn', warning: 'text-warn', mismatch: 'text-warn', running: 'text-warn', queued: 'text-warn',
  deprecated: 'text-warn', interrupted: 'text-warn',
}

/** A status word in its status colour. The word always carries the meaning; colour only repeats it. */
export function StatusText({ status, className = '' }: { status: string; className?: string }) {
  const tone = TONE[status.toLowerCase()] ?? 'text-text-2'
  return <span className={`font-medium ${tone} ${className}`}>{status}</span>
}
